<template>
  <div v-loading="loading">
    <!-- Um card só: a página (ObjectSro) e o modal já dão a moldura externa, então
         o el-card que existia aqui em volta duplicava a borda. -->
    <el-card shadow="never" class="box-card" v-show="error">
      <el-card shadow="never" style="margin-top: 40px;">
        <ObjectSroJourney
          :steps="emptySteps"
          head-label="Etiqueta não encontrada"
          head-icon-class="el-icon-question"
        />
        <p class="me-empty__hint">
          Confira o código digitado. Objetos recém-postados podem levar algumas
          horas para aparecer no rastreamento.
        </p>
      </el-card>
    </el-card>
    <el-dialog
      title="Imprimir Etiqueta"
      :visible.sync="printer"
      :close-on-click-modal="false"
      append-to-body
    >
      <ObjectSroPrintOptions
        ref="printOptions"
        :state="{ SHOW_SEPARATOR: false, SHOW_WARNING: true, SHOW_DECLARED: false }"
      />
      <el-row type="flex">
        <el-col :span="24">
          <el-button type="primary" @click="print()">Imprimir</el-button>
          <el-button type="default" @click="printer = false">Cancelar</el-button>
        </el-col>
      </el-row>
      <ObjectSroPrintPdf v-show="pdf" :content="pdf" :width="'100%'" :height="'600px'" />
    </el-dialog>
    <el-dialog
      title="Adicionar status"
      :visible.sync="dialog"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="form">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item label="Evento">
              <el-input v-model="form.event" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label="Descrição" prop="description">
              <el-input v-model="form.description" maxlength="80"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="dialog = false">Cancelar</el-button>
        <el-button type="primary" @click="event()">Criar</el-button>
      </span>
    </el-dialog>
    <el-card v-show="!error">
      <!-- Ações do objeto: ícones alinhados à direita, fora do fluxo de leitura.
           Um bloco só — o anônimo apenas não vê as duas primeiras. -->
      <div class="me-actions">
        <el-tooltip content="Suspensão de Entrega" placement="top" v-if="!anonymous">
          <el-button
            circle
            size="small"
            icon="el-icon-video-pause"
            @click="block()"
          ></el-button>
        </el-tooltip>
        <el-tooltip :content="$t('logistica-reversa')" placement="top" v-if="!anonymous">
          <el-button
            circle
            size="small"
            icon="el-icon-refresh-left"
            @click="onreverse()"
          ></el-button>
        </el-tooltip>
        <el-tooltip :content="$t('imprimir-etiqueta')" placement="top">
          <el-button
            circle
            size="small"
            icon="el-icon-printer"
            @click="printer = true"
          ></el-button>
        </el-tooltip>
      </div>
      <el-card
        shadow="never"
        class="box-card"
        v-show="show && ruleForm.step && ruleForm.step.length"
      >
        <ObjectSroJourney
          :steps="ruleForm.step"
          :created-at="ruleForm.createdAtRaw"
          :previous-at="ruleForm.previousAt"
          :finish="ruleForm.finish"
        />
      </el-card>
      <br />
      <!-- TASK-1737: em desktop, duas colunas — à esquerda uma barra fixa com
           resumo, dados do objeto e destinatário; à direita a linha do tempo, em
           largura de leitura. A ordem visual é a mesma do DOM, então em telas
           menores as colunas empilham mantendo a ordem atual da tela (dados
           acima da movimentação). -->
      <el-row :gutter="12" type="flex" class="me-track" v-show="show">
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="8"
          :xl="7"
          class="me-track__side"
        >
          <div class="me-track__sticky">
            <el-card shadow="never" class="box-card me-summary">
              <div slot="header" class="clearfix">Resumo</div>
              <div class="me-kv">
                <span class="me-kv-label">Situação</span>
                <span class="me-kv-value">{{ summaryStatus || '—' }}</span>
              </div>
              <div class="me-kv" v-if="latestTimelineItem">
                <span class="me-kv-label">Última movimentação</span>
                <span class="me-kv-value">{{ timelineDate(latestTimelineItem) }}</span>
              </div>
              <div class="me-kv" v-if="previousAtLabel">
                <span class="me-kv-label">Previsão de entrega</span>
                <span class="me-kv-value">{{ previousAtLabel }}</span>
              </div>
              <div class="me-kv">
                <span class="me-kv-label">Eventos</span>
                <span class="me-kv-value">{{ timeline.length }}</span>
              </div>
            </el-card>
            <el-card shadow="never" class="box-card" v-show="ruleForm.mytag">
              <div slot="header" class="clearfix">Dados do Objeto</div>
              <div class="me-kv">
                <span class="me-kv-label">Código</span>
                <span class="me-kv-value">
                  <span style="font-family: monospace">{{ ruleForm.etiqueta || ruleForm.tag }}</span>
                  <i
                    class="el-icon-document-copy me-kv-copy"
                    title="Copiar código"
                    @click="copyTag()"
                  ></i>
                </span>
              </div>
              <div class="me-kv">
                <span class="me-kv-label">{{ $t('peso') }}</span>
                <span class="me-kv-value">{{ ruleForm.weight || '—' }}</span>
              </div>
              <div class="me-kv" v-if="dimensoes">
                <span class="me-kv-label">Dimensões</span>
                <span class="me-kv-value">{{ dimensoes }}</span>
              </div>
            </el-card>
            <el-card shadow="never" class="box-card" v-show="ruleForm.mytag">
              <div slot="header" class="clearfix">Destinatário</div>
              <div class="me-address">
                {{ ruleForm.address }}<span v-if="ruleForm.number">, {{ ruleForm.number }}</span>
                <template v-if="ruleForm.complement"> — {{ ruleForm.complement }}</template>
                <template v-if="ruleForm.neighborhood"><br />{{ ruleForm.neighborhood }}</template>
              </div>
              <div class="me-kv">
                <span class="me-kv-label">{{ $t('cidade') }}</span>
                <span class="me-kv-value">{{ ruleForm.city }} - {{ ruleForm.state }}</span>
              </div>
              <div class="me-kv">
                <span class="me-kv-label">{{ $t('cep') }}</span>
                <span class="me-kv-value">{{ ruleForm.zipcode }}</span>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="16"
          :xl="17"
          class="me-track__main"
        >
          <el-card shadow="never" class="box-card">
            <!-- TASK-1737: uma linha do tempo só — eventos locais da etiqueta e
                 movimentações da transportadora, ordenados pelo instante no
                 backend (`history.timeline`). A criação segue no primeiro nó da
                 barra de jornada; a ocorrência automática de prepostagem fica
                 fora da tela e continua no banco. -->
            <div slot="header" class="me-timeline-head">
              <span><i class="el-icon-time"></i> Movimentação do objeto</span>
              <span class="me-timeline-meta">
                <el-button
                  v-if="user.type === '1' && ruleForm.mytag"
                  type="text"
                  class="me-timeline-add"
                  @click="dialog = true"
                  >Adicionar status</el-button
                >
                <span class="me-timeline-tag">{{ ruleForm.etiqueta || ruleForm.tag }}</span>
              </span>
            </div>
            <el-alert
              v-if="ruleForm.tracking.mensagem"
              :description="ruleForm.tracking.mensagem"
              type="error"
              :closable="false"
              show-icon
            >
            </el-alert>
            <el-alert
              v-if="!timeline.length && !ruleForm.tracking.mensagem"
              title="Aguardando movimentação do objeto"
              type="info"
              :closable="false"
              show-icon
            >
            </el-alert>
            <template v-if="timeline.length">
              <div class="me-order">
                <el-button type="text" @click="reverse = !reverse">
                  {{ reverse ? 'Mais recentes primeiro' : 'Mais antigos primeiro' }}
                  <i :class="reverse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
                </el-button>
              </div>
              <!-- Uma linha por evento: a hora fica numa coluna fixa e o
                   conteúdo começa sempre no mesmo ponto; a data aparece uma vez
                   por dia, como separador, em vez de repetir em cada item. A
                   ordem sai de `timelineRows` (e não do `reverse` do el-timeline)
                   porque o separador depende da ordem final. -->
              <el-timeline>
                <el-timeline-item
                  v-for="row in timelineRows"
                  :key="row.key"
                  hide-timestamp
                  :color="row.type === 'day' ? 'transparent' : nodeColor"
                  :size="row.latest ? 'large' : 'normal'"
                  :class="rowClass(row)"
                >
                  <div v-if="row.type === 'day'" class="me-day">{{ row.label }}</div>
                  <div v-else class="me-event">
                    <span class="me-event__time">{{ timelineTime(row.item) }}</span>
                    <div class="me-event__body">
                      <template v-if="row.item.origin === 'carrier'">
                        <div class="me-event-title">{{ row.item.title }}</div>
                        <div
                          v-if="ruleForm.tag && ruleForm.tag.startsWith('ME')"
                          class="me-event-sub"
                        >
                          Entregador: {{ row.item.entregador || 'Sem informação' }} · Placa:
                          {{ row.item.placa || 'Sem informação' }}
                        </div>
                        <div class="me-event-sub" v-if="eventLocation(row.item)">
                          {{ eventLocation(row.item) }}
                        </div>
                        <div
                          class="me-pickup"
                          v-if="isPickup(row.item) && unitFullAddress(row.item.unidade)"
                        >
                          <i class="el-icon-location-outline"></i>
                          Retirar em: {{ unitFullAddress(row.item.unidade) }}
                        </div>
                        <div class="me-event-sub" v-if="unitLocation(row.item.unidadeDestino)">
                          Para: {{ unitLocation(row.item.unidadeDestino) }}
                        </div>
                        <div class="me-event-detail" v-if="row.item.detalhe">
                          {{ row.item.detalhe }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="me-event-title">
                          {{ anonymous ? row.item.description : row.item.title }}
                        </div>
                        <template v-if="!anonymous">
                          <div
                            class="me-event-sub"
                            v-if="row.item.type === 'manual' && row.item.description"
                          >
                            {{ row.item.description }}
                          </div>
                          <div class="me-event-sub" v-if="row.item.recept">
                            Usuário: {{ row.item.recept }}
                          </div>
                          <el-button
                            v-if="row.item.type === 'manual'"
                            type="text"
                            class="me-event-remove"
                            @click="remove(row.item.id)"
                            icon="el-icon-delete"
                            >Remover</el-button
                          >
                        </template>
                      </template>
                    </div>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </template>
          </el-card>

        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { HistoryService } from "@/services/customers/history.services";
import { i18n } from "@/plugin/i18n";
import { PostOfficeService } from "@/services/post.office/post.office.services";
import { PrepostService } from "@/services/customers/prepost.services";
import { UserService } from "@/services/users/user.services";
import moment from "moment";
import ObjectSroPrintOptions from "./print/ObjectSroPrintOptions";
import ObjectSroPrintPdf from "./print/ObjectSroPrintPdf";
import ObjectSroJourney from "./ObjectSroJourney";
import { journeyHeadStep } from "./journey-head";
import { formatCalendarDate } from "@/utils/calendar-date.mjs";

// A lista é única e não distingue origem: todos os nós usam o mesmo laranja.
const NODE_COLOR = "#F47920";

// Dias da semana do separador. Outras telas trocam o locale global do moment
// (`moment.locale("pt-br")`), então o rótulo não depende dele.
const WEEKDAYS = [
  "Domingo",
  "Segunda",
  "Terça",
  "Quarta",
  "Quinta",
  "Sexta",
  "Sábado",
];

export default {
  name: "ObjectSroDetail",
  components: { ObjectSroPrintOptions, ObjectSroPrintPdf, ObjectSroJourney },
  props: ["tag"],
  watch: {
    tag() {
      this.fetchRecord();
    },
  },
  data() {
    return {
      user: {
        type: "0",
      },
      anonymous: false,
      error: false,
      loading: false,
      show: false,
      dialog: false,
      printer: false,
      reverse: true,
      nodeColor: NODE_COLOR,
      pdf: null,
      tags: [],
      form: {
        event: "",
        description: "",
      },
      ruleForm: {
        deadline: false,
        createdAt: "",
        tracking: {
          eventos: [],
          categoria: "",
        },
        timeline: [],
        active: 0,
        mytag: false,
      },
    };
  },
  computed: {
    /**
     * Espinha canônica em cinza para quando a etiqueta não é encontrada: mostra
     * o caminho que o objeto percorreria, sem afirmar nenhuma etapa. Os ids de
     * status espelham a espinha de `build-journey.ts` (1, 3, 4, 7, 5) para o
     * componente escolher os mesmos ícones.
     */
    emptySteps() {
      return [
        { title: "Pré-postagem", status: 1, state: "pending" },
        { title: "Postado", status: 3, state: "pending" },
        { title: "Em trânsito", status: 4, state: "pending" },
        { title: "Saiu para entrega", status: 7, state: "pending" },
        { title: "Entregue", status: 5, state: "pending" },
      ];
    },
    dimensoes() {
      const f = this.ruleForm || {};
      const vals = [f.length, f.width, f.height];
      if (vals.every((v) => v === undefined || v === null || v === "")) return "";
      return (
        vals
          .map((v) => (v === undefined || v === null || v === "" ? "?" : v))
          .join(" × ") + " cm"
      );
    },
    /**
     * Linha do tempo unificada montada pelo backend (`history.timeline`,
     * TASK-1737): locais + transportadora em ordem crescente de instante.
     * Vazia enquanto a resposta não a trouxer.
     */
    timeline() {
      const items = this.ruleForm && this.ruleForm.timeline;
      return Array.isArray(items) ? items : [];
    },
    latestTimelineIndex() {
      let idx = -1;
      let max = -Infinity;
      this.timeline.forEach((item, i) => {
        const t = item.at ? Date.parse(item.at) : NaN;
        if (!isNaN(t) && t >= max) {
          max = t;
          idx = i;
        }
      });
      return idx;
    },
    latestTimelineItem() {
      return this.latestTimelineIndex === -1
        ? null
        : this.timeline[this.latestTimelineIndex];
    },
    orderedTimeline() {
      return this.reverse ? this.timeline.slice().reverse() : this.timeline;
    },
    /**
     * Linhas renderizadas: um separador por dia seguido dos eventos daquele dia,
     * já na ordem escolhida pelo usuário.
     */
    timelineRows() {
      const rows = [];
      let lastDay = null;
      this.orderedTimeline.forEach((item, position) => {
        const day = this.dayKey(item);
        if (day !== lastDay) {
          rows.push({
            type: "day",
            key: "day-" + day + "-" + position,
            label: this.dayLabel(item),
          });
          lastDay = day;
        }
        rows.push({
          type: "event",
          key: "ev-" + item.origin + "-" + (item.id || position),
          item,
          latest: item === this.latestTimelineItem,
        });
      });
      return rows;
    },
    // Mesmo rótulo curto da barra de jornada; o texto do backend é o fallback.
    summaryStatus() {
      return (
        journeyHeadStep(this.ruleForm.step).title ||
        this.ruleForm.statusDescricao ||
        ""
      );
    },
    // Data civil (sem deslocar o dia pelo fuso); só enquanto não finalizado.
    previousAtLabel() {
      if (this.ruleForm.finish) return "";
      return formatCalendarDate(this.ruleForm.previousAt);
    },
  },
  methods: {
    request() {
      const vm = this;
      this.$router.replace({
        name: "request.info.add",
        params: { tag: vm.ruleForm.tag },
      });
    },
    onreverse: function () {
      const vm = this;
      this.$router.replace({
        name: "reverse.logistics.add.tag",
        params: { tag: vm.ruleForm.tag },
      });
    },
    block() {
      const vm = this;
      const tag = vm.ruleForm.tag;

      this.$confirm(
        `Deseja realizar a suspensão de entrega do objeto <strong>${tag}</strong>?`,
        'Suspensão de Entrega',
        {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          const loading = vm.$loading(vm.$options.loading);

          PrepostService.deliverySuspension(tag)
            .then(() => {
              vm.$message({
                type: 'success',
                message: `Suspensão do objeto ${tag} realizada com sucesso!`,
              });
            })
            .catch((error) => {
              vm.$message({
                type: 'error',
                message: error,
              });
            })
            .finally(() => {
              loading.close();
            });
        })
        .catch(() => {
          // Clicou em "Não" → não faz nada
        });
    },
    event() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PostOfficeService.event(vm.tag, vm.form.event, vm.form.description)
        .then((response) => {
          vm.$message({
            type: "success",
            message: "Evento criado com sucesso!",
          });
          vm.fetchRecord();
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => {
          loading.close();
        });
    },
    copyTag() {
      const vm = this;
      const tag = vm.ruleForm && (vm.ruleForm.etiqueta || vm.ruleForm.tag);
      if (!tag) return;
      const done = () =>
        vm.$message({ type: "success", message: "Código copiado!" });
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(tag).then(done).catch(() => {});
      }
    },
    unitLocation(unit) {
      if (!unit || !unit.endereco) return "";
      const cidade = unit.endereco.cidade
        ? unit.endereco.cidade + (unit.endereco.uf ? " - " + unit.endereco.uf : "")
        : "";
      return [unit.tipo, cidade].filter(Boolean).join(" · ");
    },
    eventLocation(activity) {
      return this.unitLocation(activity && activity.unidade);
    },
    isPickup(activity) {
      const text = activity && (activity.description || activity.descricao);
      return !!(text && /retirada/i.test(text));
    },
    unitFullAddress(unit) {
      if (!unit || !unit.endereco || !unit.endereco.logradouro) return "";
      const e = unit.endereco;
      const linha1 = [e.logradouro, e.numero].filter(Boolean).join(", ");
      const local = [e.cidade, e.uf].filter(Boolean).join(" - ");
      const linha2 = [e.bairro, local].filter(Boolean).join(", ");
      const cep = e.cep ? "CEP " + e.cep : "";
      return [linha1, linha2, cep].filter(Boolean).join(" — ");
    },
    stripCarrierName(v) {
      return typeof v === "string"
        ? v
            .replace(/\s*(d[oae]s?\s+)?correios/gi, "")
            .replace(/\s{2,}/g, " ")
            .trim()
        : v;
    },
    // Um evento de transportadora, venha de `tracking.eventos` (contrato antigo)
    // ou da linha do tempo: tira "Correios" dos textos e links do detalhe.
    sanitizeEvent(ev) {
      if (!ev) return;
      const stripLinks = (v) =>
        typeof v === "string" && /https?:\/\//i.test(v) ? "" : v;
      ["title", "descricao", "description"].forEach((key) => {
        if (key in ev) ev[key] = this.stripCarrierName(ev[key]);
      });
      ev.detalhe = stripLinks(this.stripCarrierName(ev.detalhe));
      if (ev.unidade) ev.unidade.tipo = this.stripCarrierName(ev.unidade.tipo);
      if (ev.unidadeDestino) {
        ev.unidadeDestino.tipo = this.stripCarrierName(ev.unidadeDestino.tipo);
      }
    },
    sanitizeCarrier(tracking) {
      if (!tracking) return;
      tracking.categoria = this.stripCarrierName(tracking.categoria);
      (tracking.eventos || []).forEach((ev) => this.sanitizeEvent(ev));
    },
    sanitizeTimeline(timeline) {
      (timeline || [])
        .filter((item) => item && item.origin === "carrier")
        .forEach((item) => this.sanitizeEvent(item));
    },
    dayKey(item) {
      const date = item && item.at ? new Date(item.at) : null;
      return date && !isNaN(date.getTime()) ? date.toDateString() : "sem-data";
    },
    dayLabel(item) {
      const date = item && item.at ? new Date(item.at) : null;
      if (!date || isNaN(date.getTime())) return "Sem data";
      return WEEKDAYS[date.getDay()] + " · " + moment(date).format("DD/MM/YYYY");
    },
    timelineTime(item) {
      if (!item) return "";
      return item.at ? moment(item.at).format("HH:mm:ss") : item.atRaw || "—";
    },
    rowClass(row) {
      return {
        "me-row--day": row.type === "day",
        "me-pulse": row.latest,
      };
    },
    timelineDate(item) {
      if (!item) return "";
      if (item.at) return moment(item.at).format("DD/MM/YYYY HH:mm:ss");
      return item.atRaw || "";
    },
    fetchRecord() {
      const vm = this;

      if (!vm.tag) {
        return vm.$message({
          type: "error",
          message: "Objeto não informado!",
        });
      }

      vm.loading = true;
      vm.error = "";

      HistoryService.get(vm.tag)
        .then((response) => {
          vm.ruleForm = response.history;
          vm.sanitizeCarrier(vm.ruleForm.tracking);
          vm.sanitizeTimeline(vm.ruleForm.timeline);
          vm.ruleForm.createdAtRaw = response.history.createdAt;
          vm.show = true;
          vm.dialog = false;
          if (!vm.ruleForm.tracking.mensagem) {
            vm.ruleForm.createdAt = vm.formatDate(vm.ruleForm.createdAt);
            const firstEvent = vm.ruleForm.tracking.eventos && vm.ruleForm.tracking.eventos[0];
            if (firstEvent && firstEvent.descricao && firstEvent.descricao.toLowerCase().includes("entregue")) {
              vm.ruleForm.deliveryAt = firstEvent.dtHrCriado;
            } else {
              vm.ruleForm.deliveryAt = "";
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
          vm.error = true;
        })
        .finally(() => {
          vm.loading = false;
        });
    },
    formatDate(date) {
      if (date && date !== "undefined") {
        const newDate = new Date(date);
        const options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        };
        return new Intl.DateTimeFormat("pt-BR", options).format(newDate);
      }
      return "";
    },
    remove(id) {
      const vm = this;
      this.$confirm(i18n.t("confirmar-eliminacao-evento"), i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        PostOfficeService.delete(id)
          .then((response) => {
            const timeline = vm.ruleForm.timeline || [];
            const index = timeline.findIndex(
              (x) => x.origin === "local" && x.id === id
            );
            if (index !== -1) timeline.splice(index, 1);
            this.$message({
              type: "success",
              duration: 5000,
              message: "Evento removido com sucesso!",
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
              duration: 5000,
            });
          })
          .finally(() => loading.close());
      });
    },
    print() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      console.log("vm.$refs.printOptions", vm.$refs.printOptions);
      PrepostService.print([vm.tag], vm.$refs.printOptions.getForm())
        .then((response) => {
          vm.pdf = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    tabsEdit(targetName, action) {
      if (action === "add") {
        let newTabName = ++this.tabIndex + "";
        this.editableTabs.push({
          title: "New Tab",
          name: newTabName,
          content: "New Tab content",
        });
        this.editableTabsValue = newTabName;
      }
      if (action === "remove") {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }

        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
      }
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
      })
      .catch((e) => {
        vm.anonymous = true;
      });
    if (vm.tag) {
      vm.fetchRecord();
    }
  },
};
</script>
<style>
.observacao {
  color: rgb(48, 107, 144);
  padding: 0;
  margin: 0;
}

.address_container {
  margin-bottom: 10px;
  font-weight: 200 !important;
}

.address_container b {
  font-weight: 300 !important;
  color: rgb(35, 34, 34);
  text-transform: uppercase;
}

.right {
  float: right;
}

.label {
  font-weight: bold;
}

.me-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 12px;
}

/* Descrição do estado vazio: mesma escala do .me-kv-label, alinhada ao
   cabeçalho da barra (que é flex à esquerda). */
.me-empty__hint {
  width: 100%;
  text-align: center;
  margin: 30px 0 0;
  font-size: 13px;
  line-height: 1.6;
  color: #909399;
}

.me-kv {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #ebeef5;
}
.me-kv:last-child {
  border-bottom: none;
}
.me-kv-label {
  color: #909399;
  font-size: 13px;
  flex-shrink: 0;
}
.me-kv-value {
  color: #303133;
  font-size: 14px;
  text-align: right;
  word-break: break-word;
}
.me-kv-copy {
  cursor: pointer;
  margin-left: 6px;
  color: #909399;
}
.me-kv-copy:hover {
  color: #22418d;
}
.me-address {
  font-size: 14px;
  line-height: 1.6;
  color: #303133;
  margin-bottom: 4px;
}
.me-order {
  text-align: right;
  margin-bottom: 4px;
}
.me-timeline-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.me-timeline-meta {
  display: flex;
  align-items: center;
  gap: 12px;
}
.me-timeline-add {
  padding: 3px 0;
}
.me-timeline-tag {
  font-weight: 400;
  color: #909399;
  font-family: monospace;
  font-size: 13px;
}
/* Duas colunas (>= 1200px): linha do tempo + barra lateral fixa. Abaixo disso
   as colunas empilham na ordem do DOM (dados, depois movimentação). */
.me-track.el-row--flex {
  flex-wrap: wrap;
}
.me-track__side .box-card + .box-card {
  margin-top: 12px;
}
.me-track__main {
  margin-top: 12px;
}
.me-summary {
  display: none;
}
@media (min-width: 1200px) {
  .me-track__main {
    margin-top: 0;
  }
  .me-track__sticky {
    position: sticky;
    top: 12px;
  }
  .me-summary {
    display: block;
  }
}
/* Evento: hora em coluna de largura fixa, com algarismos tabulares, para os
   horários formarem uma coluna reta e os títulos começarem sempre no mesmo x. */
.me-event {
  display: flex;
  align-items: baseline;
  gap: 12px;
}
.me-event__time {
  flex: 0 0 56px;
  font-size: 13px;
  color: #909399;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
}
.me-event__body {
  flex: 1;
  min-width: 0;
}
/* Separador de dia: sem nó, para a linha vertical seguir contínua. */
.me-day {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #909399;
}
.me-row--day {
  padding-bottom: 10px;
}
.me-row--day .el-timeline-item__node {
  display: none;
}
.el-timeline-item + .me-row--day {
  padding-top: 8px;
}
.me-event-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}
.me-event-sub {
  font-size: 13px;
  color: #606266;
  margin-top: 2px;
}
.me-event-detail {
  font-size: 13px;
  color: #306b90;
  margin-top: 4px;
}
.me-event-remove {
  color: #f25c5c;
  padding: 0;
  margin-top: 4px;
}
.me-pulse .el-timeline-item__node {
  box-shadow: 0 0 0 4px rgba(244, 121, 32, 0.3),
    0 0 0 9px rgba(244, 121, 32, 0.13);
}
.me-pickup {
  margin-top: 6px;
  padding: 8px 10px;
  background: #fdf6ec;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #303133;
}
.me-pickup i {
  color: #f47920;
  margin-right: 4px;
}
</style>
